<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          {{ appName }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <div class="image-part common">
            <div class="image-wrap">
              <img class="ball animate6" src="@/assets/images/slider/h1-layer2.png" width="500px" alt="">
              <img class="player animate5" src="@/assets/images/slider/ball2.png" width="70px" alt="">
            </div>
          </div>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            智能竞猜从这里开始 🚀
          </b-card-title>
          <b-card-text class="mb-2">
            让竞猜之旅更简单更有趣!
          </b-card-text>

          <!-- form -->
          <validation-observer ref="registerForm">
            <b-form class="auth-register-form mt-2">
              <!-- username -->
              <b-form-group label="登录账号" label-for="register-username">
                <validation-provider #default="{ errors }" name="Username" rules="required">
                  <b-form-input id="register-username" v-model="username" name="register-username"
                    :state="errors.length > 0 ? false : null" placeholder="请输入登录账号" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group label="登录邮箱" label-for="register-email">
                <validation-provider #default="{ errors }" name="Email" rules="required|email">
                  <b-form-input id="register-email" v-model="userEmail" name="register-email"
                    :state="errors.length > 0 ? false : null" placeholder="请输入登录邮箱" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group label-for="register-password" label="登录密码">
                <validation-provider #default="{ errors }" name="Password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="register-password" v-model="password" class="form-control-merge"
                      :type="passwordFieldType" :state="errors.length > 0 ? false : null" name="register-password"
                      placeholder="············" />
                    <b-input-group-append is-text>
                      <feather-icon :icon="passwordToggleIcon" class="cursor-pointer"
                        @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox id="register-privacy-policy" v-model="status" name="checkbox-1">
                  注册即同意
                  <b-link>用户协议</b-link>
                </b-form-checkbox>
              </b-form-group>

              <b-button variant="primary" block type="submit" @click.prevent="validationForm">
                立即注册
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>已有账号?</span>
            <b-link :to="{ name: 'login' }">
              <span>&nbsp;立即登录</span>
            </b-link>
          </p>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              联系我们
            </div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)" v-b-popover.hover.top="'footballprediction88'"
              title="请添加微信号：">
              <!-- <b-avatar size="15" src="@/assets/images/register/wechat.png" /> -->
              <img src="@/assets/images/register/wechat.png" width="16" height="16" alt="qr-code1" />
            </b-button>
            <b-button variant="facebook" href="javascript:void(0)" v-b-popover.hover.top="'296682978'" title="请添加QQ：">
              <b-avatar size="15" src="@/assets/images/register/qq.png" />
              <!-- <img src="@/assets/images/register/qq.png" width="16" height="16" alt="qr-code2" -->
              <!-- <feather-icon icon="FacebookIcon" /> -->
            </b-button>
          </div>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>

    <!--弹窗-->
    <div class="modal fade" id="sizingLargeModal">
      <div class="modal-dialog modal-lg col-lg-12 col-md-12">
        <div class="modal-content col-lg-12 col-md-12">
          <div class="modal-header">
            <h1 class="modal-title fs-5">选择开通类型</h1>
            <b-button variant="flat-secondary" @click="closeModel()">
              <feather-icon icon="XIcon" class="mr-50" />
              <span class="align-middle">关闭</span>
            </b-button>
          </div>
          <!--内容-->
          <div class="modal-body text-bg-light ">

            <div class="row  ">
              <div class="col-lg-12 col-md-12 ">
                <Pricing :priceData="viplist" @chooseCard="selectCard" />
              </div>

              <div class="col-lg-12 col-md-12 mt-2">
                <PayDetail :payData="select_vip_card" />
              </div>

            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModel()">
              返回
            </button>
            <button type="button" class="btn btn-success" @click="payOrder()">
              我已支付
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Modal } from "bootstrap";
import request from '@/utils/request.js';

import Pricing from "./Pricing.vue";
import PayDetail from "./PayDetail.vue";

import { $themeConfig } from '@themeConfig'


export default {
  components: {
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
    Pricing,
    PayDetail
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      username: '',
      userEmail: '',
      password: '',
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,
      viplist: [],
      isselect: '',
      select_vip_card: '',
      myModal: ''
    }
  },
  mounted() {
    this.getCardList();
    let myModal = new Modal(document.getElementById('sizingLargeModal'));
    this.myModal = myModal;
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    selectVIP(a, b) {
      this.isselect = a
      this.select_vip_card = b
    },
    selectCard(cardItem) {
      this.select_vip_card = cardItem
    },
    closeModel() {
      this.myModal.hide();
    },

    async getCardList() {
      let post_url = 'football/admin/william/interfaceAction!getCardList.action';
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      request.openHttpRequest(opts).then(response => {

        if (response == null) {
          this.showToast('warning', 'top-center', '通知', '网络连接异常');
          // this.$message.error('网络连接异常');
          return;
        }
        if (response.data.status == 0) {
          this.$message.error(response.data.message);
          return;
        }
        this.viplist = response.data.cardList;
        // this.select_vip_card = this.viplist[0];
      });
    },

    showToast(variant, position, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: 'InfoIcon',
          text,
          variant,
        },
      },
        {
          position,
        })
    },

    payOrder() {
      if (!this.select_vip_card) {
        this.showToast('warning', 'top-center', '通知', '请选择开通类型')
        // ElMessage({
        //   message: '请选择开通类型',
        //   type: 'warning',
        // })
        return;
      }
      this.myModal.hide();
      // username: '',
      // userEmail: '',
      // password: '',

      let post_url = 'football/admin/william/interfaceAction!register.action';
      post_url = post_url + '?userName=' + this.username + "&password=" + this.password +
        "&registerType=" + this.select_vip_card.type + "&email=" + this.userEmail;
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      this.loading = true;
      request.openHttpRequest(opts).then(response => {
        this.loading = false;
        if (response == null) {
          this.showToast('danger', 'top-center', '通知', '网络错误')

          // ElMessage({
          //   message: '网络错误',
          //   type: 'danger',
          // })
          return;
        }

        if (response.status == 200) {

          if (response.data.status == 0) {
            this.showToast('danger', 'top-center', '通知', response.data.message)

            // ElMessage({
            //   message: response.data.message,
            //   type: 'danger',
            // })
            return;
          }

          // ElNotification({
          //   title: '等待查询付款记录',
          //   message: '请耐心等待系统查询付款状态，预计等待时间5min.',
          //   type: 'success',
          //   duration: 10000,
          // })
          this.showToast('success', 'top-center', '等待查询付款记录', '请耐心等待系统查询付款状态，预计等待时间5min.')


          this.showToast('success', 'top-center', '等待查询付款记录', '系统收到付款信息将以邮件的形式通知已开通')
          // ElNotification({
          //   title: '等待查询付款记录',
          //   message: '系统收到付款信息将以邮件的形式通知已开通',
          //   type: 'success',
          //   duration: 10,
          // })

          // ElMessage({
          //   message: '注册成功',
          //   type: 'success',
          // })

          // 存储数据到本地缓存

          localStorage.setItem('soccer_username', this.username);
          localStorage.setItem('soccer_password', this.password);



          this.$router.push('/login');



        }
      });

    },




    validationForm() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          // this.showToast('info', 'bottom-center')
          this.myModal.show();
        }
      })
    },
  },

  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
